<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><em><a id="page-vii"></a>Dedicated to <br/>All the readers who love The Mage books. <br/>Thank you.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?59960480